module.exports = __webpack_public_path__ + "static/media/P200-Tip-Solution-Blue.ade716f1.svg";